require('./brokerKnowTheseStocks.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @components
const { BrokerKnowTheseStocksList } = require('./BrokerKnowTheseStocksList');

// @ actions
const brokerKnowTheseStocksActions = require('actions/brokerKnowTheseStocks');

// @ commons
const { TabbedContentBox } = require('commonsComponents/tabbedContentBox');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @constants
const {
    BROKER_STOCKS_TYPE_FOOTBALL,
    BROKER_STOCKS_TYPE_SOCIAL_MEDIA,
    BROKER_STOCKS_DEFAULT_TAB
} = require('constants/brokerKnowTheseStocks');


class BrokerKnowTheseStocks extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const footballClubStocks = (<BrokerKnowTheseStocksList
            key={BROKER_STOCKS_TYPE_FOOTBALL}
            stocksType={BROKER_STOCKS_TYPE_FOOTBALL}
            getStocksDetails={this.props.getStocksDetails}
            immBrokerStocks={this.props.immBrokerKnowTheseStocks.get(BROKER_STOCKS_TYPE_FOOTBALL)}
            onHandleBuyClick={this.props.onHandleBuyClick}
            onHandleAdvancedSearchClick={this.props.onHandleAdvancedSearchClick}
            pageName={this.props.pageName}
        />);
        const socialMediaStocks = (<BrokerKnowTheseStocksList
            key={BROKER_STOCKS_TYPE_SOCIAL_MEDIA}
            stocksType={BROKER_STOCKS_TYPE_SOCIAL_MEDIA}
            getStocksDetails={this.props.getStocksDetails}
            immBrokerStocks={this.props.immBrokerKnowTheseStocks.get(BROKER_STOCKS_TYPE_SOCIAL_MEDIA)}
            onHandleBuyClick={this.props.onHandleBuyClick}
            onHandleAdvancedSearchClick={this.props.onHandleAdvancedSearchClick}
            pageName={this.props.pageName}
        />);

        const tabLabels = [
            <div onClick={() => taggingEventHandled(this.props.pageName, 'knowTheseStocksSlider', 'banks')}>
                {formatText('broker-knowTheseStocksTabFootball')}
            </div>,
            <div onClick={() => taggingEventHandled(this.props.pageName, 'knowTheseStocksSlider', 'day-to-day companies')}>
                {formatText('broker-knowTheseStocksTabSocialMedia')}
            </div>
        ]

        return (
            <div>
                <TabbedContentBox
                    id="brokerKnowTheseStocks"
                    customClassName="broker-know-these-stocks"
                    tabComponents={[footballClubStocks, socialMediaStocks]}
                    tabLabels={tabLabels}
                    title={<FormattedText value="broker-knowTheseStocksTitle" />}
                    defaultTabIndex={BROKER_STOCKS_DEFAULT_TAB}
                    tabsAsPills={true}
                    applyMaxWidthTitleContentBox
                />
            </div>
        );

    }

}

BrokerKnowTheseStocks.propTypes = {
    immBrokerKnowTheseStocks: PropTypes.object.isRequired,
    getStocksDetails: PropTypes.func.isRequired,
    onHandleBuyClick: PropTypes.func.isRequired,
    onHandleAdvancedSearchClick: PropTypes.func.isRequired,
    pageName: PropTypes.string
}

module.exports.constructor = BrokerKnowTheseStocks;
module.exports.BrokerKnowTheseStocks = connect(
    state => ({
        immBrokerKnowTheseStocks: state.brokerKnowTheseStocks
    }), {
        getStocksDetails: brokerKnowTheseStocksActions.getStocksDetails
    })(BrokerKnowTheseStocks);
